import { OneWayInClosedReason, OneWayInOpportunityStatusCreateDto, OneWayInStatus } from 'src/api/v2';

const createOwiUpdateDto = (
  opportunityId,
  status: OneWayInStatus,
  comment: string,
  userId: string | undefined,
  handlersName?: string | undefined,
  closedReason?: OneWayInClosedReason | undefined,
  sendFollowUpReminderOn?: Date,
): OneWayInOpportunityStatusCreateDto => ({
  oneWayInOpportunityId: opportunityId,
  referenceClusterId: undefined,
  status: status,
  description: comment,
  closedReason: closedReason,
  registeredServices: [],
  recommendedServices: [],
  clusterContactId: undefined,
  clusterUserId: userId,
  handlersName: handlersName,
  sendFollowUpReminderOn: sendFollowUpReminderOn,
  admittedToProgram: false,
  sivaPhase: undefined,
  deliveredOn: undefined,
});

export default createOwiUpdateDto;
